module.exports = __webpack_public_path__ + "static/media/skeleton.3c82e6ef.mp3";